import { render, staticRenderFns } from "./FindRecord.vue?vue&type=template&id=24367c8e&scoped=true"
import script from "./FindRecord.vue?vue&type=script&lang=js"
export * from "./FindRecord.vue?vue&type=script&lang=js"
import style0 from "./FindRecord.vue?vue&type=style&index=0&id=24367c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24367c8e",
  null
  
)

export default component.exports